<script>
  import {createEventDispatcher, onMount} from 'svelte';
  import {PAGE_INTRO, PAGE_PURPOSES, PAGE_VENDORS} from '../constants';
  import DialogWrapper from './wrappers/DialogWrapper.svelte';
  import PageIntro from './pages/PageIntro.svelte';
  import PagePurposes from './pages/PagePurposes.svelte';
  import PageVendors from './pages/PageVendors.svelte';
  import {getVendors} from '../vendors';
  import {inProfile} from '../utils/scriptParams';
  // import {navPage} from '../services/measurement';
  import {demoMode} from '../utils/urlParams';
  import '../../css/styles.pcss';

  export let page = PAGE_INTRO;
  export let hasPrevConsent = false;
  export let userType = '';
  export let formData = {};
  export let userLoggedIn = true;
  export let test = false;
  export let consentPage = false;

  let submiting = false;

  const dispatch = createEventDispatcher();
  const setPage = destination => (page = destination);
  const handleSubmit = screen => dispatch('agreed', {screen});
  const handleFailure = () => dispatch('failure');
  const handleExitIconClick = ({detail}) => {
    const {screen} = detail;
    dispatch('exit', {screen});
  };
  const handleButtonClick = ({detail}) => {
    const {type, navigation, screen} = detail;

    if (type === 'submit' && !demoMode()) {
      getVendors()
        .then(() => handleSubmit(screen))
        .catch(() => handleFailure());
      submiting = true;
    } else if (navigation !== null) {
      if (!inProfile()) {
        //navPage(navigation);
      }
      setPage(navigation);
    }
  };

  // for testing purposes - delete
  if (test) {
    onMount(() => {
      document.querySelector('.scmp_Button--submit').click();
    });
  }
</script>

<DialogWrapper {userType} {test}>
  {#if page === PAGE_INTRO}
    <PageIntro
      {submiting}
      {hasPrevConsent}
      {userType}
      {userLoggedIn}
      {consentPage}
      on:buttonClick={handleButtonClick}
      on:exit={handleExitIconClick} />
  {:else if page === PAGE_PURPOSES}
    <PagePurposes {submiting} {formData} {userType} {userLoggedIn} on:buttonClick={handleButtonClick} on:exit={handleExitIconClick} />
  {:else if page === PAGE_VENDORS}
    <PageVendors {submiting} {formData} {userType} on:buttonClick={handleButtonClick} on:exit={handleExitIconClick} />
  {/if}
</DialogWrapper>
